import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';
import { Plane, MapPin, Clock, ArrowRight, CreditCard } from 'lucide-react';

const services = [
  {
    icon: Plane,
    titleKey: 'service_airport',
    descKey: 'service_airport_desc',
    bookingType: 'airport_transfer',
  },
  {
    icon: MapPin,
    titleKey: 'service_distance',
    descKey: 'service_distance_desc',
    bookingType: 'distance',
  },
  {
    icon: Clock,
    titleKey: 'service_hourly',
    descKey: 'service_hourly_desc',
    bookingType: 'hourly',
  },
];

export const ServicesSection = () => {
  const { t } = useLanguage();

  return (
    <section id="services" className="py-24 bg-[#0A0A0A]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="uppercase text-xs tracking-[0.3em] text-[#D4AF37] mb-4">
            What We Offer
          </p>
          <h2 
            className="text-3xl sm:text-4xl lg:text-5xl font-light text-white mb-4"
            style={{ fontFamily: 'Cormorant Garamond, serif' }}
            data-testid="services-title"
          >
            {t('services_title')}
          </h2>
          <p className="text-[#A1A1AA] max-w-2xl mx-auto">
            {t('services_subtitle')}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Link
              key={index}
              to={`/booking?type=${service.bookingType}`}
              className="group p-8 bg-[#121212] border border-white/10 hover:border-[#D4AF37]/50 transition-all duration-500 card-hover cursor-pointer block"
              data-testid={`service-card-${index}`}
            >
              <div className="w-14 h-14 flex items-center justify-center border border-[#D4AF37] text-[#D4AF37] mb-6 group-hover:bg-[#D4AF37] group-hover:text-black transition-all duration-500">
                <service.icon className="w-6 h-6" />
              </div>
              <h3 
                className="text-xl sm:text-2xl text-white mb-4"
                style={{ fontFamily: 'Cormorant Garamond, serif' }}
              >
                {t(service.titleKey)}
              </h3>
              <p className="text-[#A1A1AA] text-sm leading-relaxed mb-4">
                {t(service.descKey)}
              </p>
              
              {/* Payment Info Badge */}
              <div className="flex items-center gap-2 text-sm text-[#A1A1AA] mb-6 p-2 bg-[#0A0A0A] border border-white/5">
                <CreditCard className="w-4 h-4 text-[#D4AF37]" />
                <span>{t('payment_info')}</span>
              </div>
              
              <div className="flex items-center gap-2 text-[#D4AF37] text-sm font-medium group-hover:gap-4 transition-all duration-300">
                <span>{t('nav_booking')}</span>
                <ArrowRight className="w-4 h-4" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
